import PageHeader from "../../Components/BaseComponents/pageHeader";

export default function Users() { 
  return (
    <PageHeader topHeader='Users' subHeader='Overview'/>
  );
}